import styled from 'styled-components';

export const PollAnswerWrapper = styled.div`
    display: grid;
    grid-template-columns: auto 50px;
    align-items: center;
`;

export const AddAnswerButton = styled.button`
    outline: none;
    border: none;
    background-color: unset;
    color: ${({ theme }) => theme.colors.primary};
    text-transform: uppercase;
    padding: none;
    font-size: 12px;
    font-weight: bold;
    margin: ${({ theme }) => theme.spacing * 4}px 0 ${({ theme }) => theme.spacing * 8}px;
    cursor: pointer;
`;

export const PreviewWrapper = styled.div`
    height: 64px;
    margin-top: ${({ theme }) => theme.spacing * 4}px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${({ theme }) => theme.colors.paleBlue};
    border-radius: 6px;
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.primary};
    cursor: pointer;
    > svg {
        margin-right: ${({ theme }) => theme.spacing * 2}px;
    }
`;

export const MediaDescription = styled.p`
    font-size: 12px;
    color: #032a558a;
    margin: ${({ theme }) => theme.spacing}px 0 ${({ theme }) => theme.spacing * 6}px;
`;
